var React = require('react');

function ShareAlt (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22 20a6 6 0 1 1-6 6v-.002c0-.363.064-.946.142-1.301l-6.405-4.003a6 6 0 1 1 0-9.388l6.405-4.003a6 6 0 1 1 2.121 3.391l-6.405 4.003c.079.355.142.939.142 1.303s-.064.947-.142 1.303l6.405 4.003A5.976 5.976 0 0 1 22 20z"}));
}

ShareAlt.defaultProps = {"viewBox":"0 0 28 32"};

module.exports = ShareAlt;

ShareAlt.default = ShareAlt;
